import React from 'react';
import { SearchResultsCountProps } from './../../../types/search';
import { useSearchConfig } from '../hooks/useSearchConfig';

const SearchResultsCount = ({ startResult, endResult, totalResults }: SearchResultsCountProps) => {
  const { labels } = useSearchConfig();

  const parts = labels.viewingResultsLabel.split(/(\{startResult\}|\{endResult\}|\{totalResults\})/);
  const isHidden = totalResults === 0;

  return (
    <div className={`search-results-count${isHidden ? ' search-results-count--hidden' : ''}`}>
      <p className="search-results-count__text">
        {parts.map(part => {
          if (part === '{startResult}') {
            return <strong key="start-result">{startResult}</strong>;
          }
          if (part === '{endResult}') {
            return <strong key="end-result">{endResult}</strong>;
          }
          if (part === '{totalResults}') {
            return <strong key="total-results">{totalResults}</strong>;
          }
          return part || null;
        })}
      </p>
    </div>
  );
};

export default SearchResultsCount;
